import { AppsService } from '@/common/apps/apps.service';
import lowerCase from 'lodash/lowerCase';
import { useUserSettingsStore } from '@/stores/user-settings.store';

function getTrendsAppIdFromUserSettings () {
    const trendsDataSettings = useUserSettingsStore().settingByName('trends-data-settings', true)?.value;

    if (trendsDataSettings?.appId) {
        return trendsDataSettings.appId;
    }

    if (trendsDataSettings?.app?.id) {
        return trendsDataSettings.app.id;
    }

    return undefined;
}

export function getAppId (rootGetters) {
    const availableApps = rootGetters['apps/analyticsAppsListWithIcons'] ?? [];
    const legacyApp = availableApps.find((app) => app.id === AppsService.legacyAppId);

    return getTrendsAppIdFromUserSettings() ?? legacyApp?.id ?? rootGetters['apps/firstAvailableApp']?.id;
}

function getItemByType (itemType, itemId, rootGetters) {
    if (itemType === 'Page') {
        return rootGetters['pages/pageById'](itemId);
    }
    if (itemType === 'Feature') {
        return rootGetters['features/featureById'](itemId);
    }
    if (itemType === 'TrackType') {
        return rootGetters['trackTypes/trackTypeById'](itemId);
    }

    return null;
}

export default {
    namespaced: true,
    getters: {
        getApp: (state, getters, rootState, rootGetters) => {
            const appId = getAppId(rootGetters);

            return {
                id: appId,
                name: rootGetters['apps/appNameFromId'](appId),
                icon: rootGetters['apps/getIconByAppId'](appId)?.type,
            };
        },
        getAppDisplayName (state, getters, rootState, rootGetters) {
            const app = getters.getApp;
            if (!app?.id) return '';

            const fullApp = rootGetters['apps/getAppById'](app.id);

            return fullApp?.displayName || fullApp?.name || app.name || '';
        },
        getSegmentId: () => {
            const trendsDataSettings = useUserSettingsStore().settingByName('trends-data-settings', true)?.value;

            return trendsDataSettings?.segmentId ?? 'everyone';
        },
        getEvents: (state, getters, rootState, rootGetters) => {
            const trendsDataSettings = useUserSettingsStore().settingByName('trends-data-settings', true)?.value;

            if (trendsDataSettings) {
                const { events } = trendsDataSettings;

                const selectedAppId = getAppId(rootGetters);

                if (events) {
                    // Normalize events to array (handle both array and object formats)
                    const eventsArray = Array.isArray(events) ? events : Object.values(events);

                    return eventsArray
                        .map((event) => {
                            if (!event) {
                                return null;
                            }

                            const { kind, id } = event;

                            if (!kind || !id) {
                                return null;
                            }

                            // Always verify the item still exists in the system
                            const itemDetails = getItemByType(kind, id, rootGetters);
                            if (!itemDetails || itemDetails.appId !== selectedAppId) {
                                return null;
                            }

                            return {
                                id,
                                icon: kind === 'TrackType' ? 'zap' : lowerCase(kind),
                                name: itemDetails.name,
                                kind,
                                appId: itemDetails.appId,
                            };
                        })
                        .filter((event) => !!event);
                }
            }

            return [];
        },
    },
};
